import axios from "axios";
import { baseApiUrl, getHttpHeaders, getHttpHeadersExcel, httpRequest } from "./ApiUtils";


const welcomeSessionApiUrl = `${baseApiUrl}/api/WelcomeSession`;

export async function getWelcomeSessionEmployees(lastDays) {
    return await httpRequest(fetchWelcomeSessionEmployees.bind(this, lastDays));
}

async function fetchWelcomeSessionEmployees(lastDays) {
    let config = getHttpHeaders();
    return await axios.get(`${welcomeSessionApiUrl}/NewEmployees?lastDays=${lastDays}`, config);
}

export async function notifyConsultants(values) {
    return await httpRequest(postNotifyConsultants.bind(this, values));
}

async function postNotifyConsultants(values) {
    let config = getHttpHeaders();
    return await axios.post(`${welcomeSessionApiUrl}`, values, config);
}

export async function getWelcomeSessionExcel() {
    return await httpRequest(fetchgetWelcomeSessionExcel.bind(this));
}
async function fetchgetWelcomeSessionExcel() {
    let config = getHttpHeadersExcel();
    return await axios.get(`${welcomeSessionApiUrl}/WelcomeSessionExcel`, config);
}
